<template>
    <v-card flat class="score-trans">
        <v-container fluid>
            <v-row dense v-if="Array.isArray(bookings)">
                <v-col cols="12">
                    <div class="small-font ml-4 mb-2 d-flex justify-space-between">
                        <div><b>Today's bookings <span v-if="Array.isArray(bookings)">({{ this.bookings.length }})</span></b></div>
                        <div class="mr-4 link-font-size">Highest value <span class="link-color" v-on:click="openHighestBooking()">{{ getHighestBookingNumber() }}</span> - {{ getHighestBookingAmount() }}</div>
                    </div>
                    <left_panel_bookings_table :bookings="this.bookings" :height_correction="this.height_correction"/>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<style scoped>
.link-color{
    color: blue !important;
    cursor: pointer;
}
.link-font-size{
    font-size: 14px !important;
}
</style>

<script>

import left_panel_bookings_table from '@/components/dashboard/sections/left_panel_bookings_table.vue';

export default {    
    props: {
        bookings: Array,
        height_correction: Number,
    },    
    components: {
        left_panel_bookings_table,
    },
    methods: {
        getHighestBooking() {
            if (!Array.isArray(this.bookings) || this.bookings.length === 0) {
                return null;
            }
            
            return this.bookings.reduce((max, booking) => {
                const bookingValue = parseFloat(booking.dvalue) || 0;
                const maxValue = parseFloat(max.dvalue) || 0;
                return bookingValue > maxValue ? booking : max;
            });
        },
        getHighestBookingNumber() {
            const highest = this.getHighestBooking();
            return highest ? highest.bookingnr : '';
        },
        getHighestBookingAmount() {
            const highest = this.getHighestBooking();
            if (!highest) {
                return '';
            }
            
            const value = parseFloat(highest.dvalue) || 0;
            return new Intl.NumberFormat('nl-NL', { 
                style: 'currency', 
                currency: 'EUR' 
            }).format(value);
        },
        openHighestBooking() {
            const highest = this.getHighestBooking();
            if (highest && highest.huov_encrid) {
                this.$router.open('/huov/onHuov/' + highest.huov_encrid);
            }
        }
    } 
}

</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
</style>